import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../ui/base-components/pai-button';
import PaiTextField from '../ui/base-components/pai-text-field';

interface Props {
  open: boolean;
  projectName: string;
  nameTakenError: boolean | undefined;
  loading?: boolean;

  handleProjectNameChange(event: React.ChangeEvent<HTMLInputElement>): void;

  handleClose(): void;

  acceptProjectName(): void;
}

const EnterProjectNameDialog: React.FC<Props> = ({
  open,
  projectName,
  nameTakenError,
  loading,
  handleProjectNameChange,
  handleClose,
  acceptProjectName,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('createNewProject')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <PaiTextField value={projectName} placeholder={t('enterProjectName')} onChange={handleProjectNameChange} />
        {nameTakenError ? <Typography className={classes.errorText}>{t('nameAlreadyTakenError')}</Typography> : null}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} action={acceptProjectName} disabled={projectName.trim() === '' || loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  errorText: {
    fontSize: theme.typography.pxToRem(11),
    color: 'red',
    marginTop: '4px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default EnterProjectNameDialog;
